import React, {useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'

const DeeplinkRedirect = (props) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const referrer = urlParams.get('referrer')

    const [deviceType, setDeviceType] = useState({
        isAndroid: false, isIOS: false, website: false, other: true
    })

    useEffect(() => {
        checkDeviceType()
    }, [])

    useEffect(() => {
        if(deviceType.other === false) {
            if (deviceType.isAndroid === true) {
                window.location.replace(`https://play.google.com/store/apps/details?id=com.revfin_ptech18&referrer=${referrer}`)
            } else if (deviceType.isIOS === true) {
                window.location.replace('https://apps.apple.com/in/app/revfin/id1454364758')
            } else if (deviceType.website === true){
                props.history.push('/')
            } else {
                console.log('Error')
            }
        }
    }, [deviceType])

    const checkDeviceType = () => {
        const isAndroidDevice = navigator.userAgent.toLowerCase().indexOf("android") > -1;
        const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        if (isAndroidDevice) {
            setDeviceType({...deviceType, other: false, isAndroid: true})
        } else if (isIOSDevice) {
            setDeviceType({...deviceType, other: false, isIOS: true})
        } else {
            setDeviceType({...deviceType, other: false, website: true})
        }
    }

    return (<div></div>)
}

export default withRouter(DeeplinkRedirect)


// WEBPACK FOOTER //
// ./src/components/DeeplinkRedirect.js